var map = {
	"./bs_web_frame_base01_.png": 415294,
	"./bs_web_frame_base01_blk.png": 218705,
	"./bs_web_frame_base01_blu.png": 361967,
	"./bs_web_frame_base01_cho.png": 674968,
	"./bs_web_frame_base01_cml.png": 687684,
	"./bs_web_frame_base01_crk.png": 873442,
	"./bs_web_frame_base01_dor.png": 766779,
	"./bs_web_frame_base01_gld.png": 138547,
	"./bs_web_frame_base01_grn.png": 74339,
	"./bs_web_frame_base01_gry.png": 98012,
	"./bs_web_frame_base01_lmn.png": 508025,
	"./bs_web_frame_base01_mgn.png": 125078,
	"./bs_web_frame_base01_nvy.png": 473853,
	"./bs_web_frame_base01_orn.png": 489195,
	"./bs_web_frame_base01_pnk.png": 224665,
	"./bs_web_frame_base01_ppl.png": 824552,
	"./bs_web_frame_base01_red.png": 596865,
	"./bs_web_frame_base01_sax.png": 842164,
	"./bs_web_frame_base01_sil.png": 202667,
	"./bs_web_frame_base01_wht.png": 866271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650029;